import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const VisitTypeFilter = ({
    onChange,
    value
}) => {

    const options = [
        { value: '', label: 'All' },
        { value: '1', label: 'Home Visit' },
        { value: '0', label: 'Center Visit' }
    ];

    const [selectedValue, setSelectedValue] = useState(options[0]);

    useEffect(() => {
        const selected = options.find(opt => opt.value === (value || ''));
        if (selected) {
            setSelectedValue(selected);
        }
    }, [value]);

    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption || options[0]);
        onChange(selectedOption ? selectedOption.value : '');
    }

    return <Select
        onChange={handleChange}
        options={options}
        value={selectedValue}
        styles={{
            control: (provided) => ({
                ...provided,
                minHeight: '40px',
                fontSize: '12px'
            }),
            menu: (provided) => ({
                ...provided,
                maxHeight: '300px',
                overflowY: 'auto',
                zIndex: 9999
            }),
            menuList: (provided) => ({
                ...provided,
                maxHeight: '300px',
                overflowY: 'auto'
            }),
            option: (provided) => ({
                ...provided,
                fontSize: '12px'
            })
        }}
        menuPlacement="auto"
        menuPosition="fixed"
    />
}

export default VisitTypeFilter
